<ng-container *ngIf="isBusClassCompute">
    <div [ngClass]="{'lm-is-radio-in-paragraph': lmParagraphLayoutInfo, 'lm-radio-field-options': true}">
        <input type="radio"
               class="radio"
               soho-radiobutton (change)="handleComputeTypeChange($event)"
               soho-trackdirty
               id="option1ComputeType" attr.name="optionsComputeType" value="compute"
               [(ngModel)]="computeType"/>
        <label soho-label for="option1ComputeType" [forRadioButton]="true" class="lm-radio-button-label">{{ 'ComputeEditorColumnComputeLabel' | translate}}</label>
        <input type="radio"
               class="radio"
               soho-radiobutton (change)="handleComputeTypeChange($event)"
               soho-trackdirty
               id="option2ComputeType" attr.name="optionsComputeType" value="derived"
               [(ngModel)]="computeType"/>
        <label soho-label for="option2ComputeType" [forRadioButton]="true" class="lm-radio-button-label">{{ 'DerivedLabel' | translate}}</label>
    </div>
</ng-container>
<label *ngIf="label"
  [attr.for]="id"
  soho-label
    [required]="isRequired"
  lm-label
    [layoutField] = "field"
>{{triggerValue| formatLabelRule:field:labelResourceValue:model:specFields}}</label>
<div class="field">
    <div
        lm-field-options
        [hasContextMenu]="insertContextMenu"
        [ajaxCallbackFunction]="onBeforeContextMenuOpen"
        [contextMenuEventFunction]="contextMenuClicked"
        [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
        [buttonId]="fieldOptionsId"
        [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
        [isInAccessibilityMode]="isInAccessibilityMode"
        [displayFieldOptions]="displayFieldOptions"
        [fieldAutomationId]="fieldAutomationId"
        soho-tooltip
        [popover]="true"
        [title]="popoverTitle"
        [placement]="'right'"
        [trigger]="'click'"
        (focusin)="onFieldFocus($event)"
        (focusout)="onFieldBlur($event)"
        (contextmenu)="onContextMenu($event)">
        <ng-container *ngIf="!displayAsText; else displayField">
            <div class="bcf-editor">
                <div class="editor-container lm-lpl-editor" #editorContainer soho-alert soho-trackdirty [attr.id]="id" [attr.bindId]="bindId"></div>
            </div>
        </ng-container>
        <ng-template #displayField>
            <p
                [attr.id]="id"
                [ngClass]="fieldClassesString"
                [attr.tabindex]="isInAccessibilityMode ? 0 : -1"
                soho-alert
                lm-field-style
                [specField]="specField"
                [fieldStyle]="layoutObject?.fieldStyle"
            >{{modelField.value | formatMessageRule:true:field.text:model:specFields}}</p>
        </ng-template>
    </div>
</div>
<ng-container *ngIf="!displayAsText">
    <ng-container *ngIf="isBusClassTotal; else others">
        <div class="two-button">
            <button
                    soho-button="primary"
                    [disabled]="disableDimensions"
                    (click)="onBuildCubeRelation($event)"
            >{{ 'SetDimensions' | translate}}
            </button>
            <ng-template [ngIf]="!hideTestMeasures">
                <button
                        soho-button="secondary"
                        (click)="onPreviewCubeRelation($event)"
                >{{ 'Validate' | translate }}
                </button>
            </ng-template>
        </div>
    </ng-container>
    <ng-template #others>
        <ng-container *ngIf="!isBusClassCompute; else compute">
            <div class="two-button">
                <button
                        soho-button="primary"
                        [disabled]="isReadOnly"
                        (click)="onBuildButtonEvent($event)"
                >{{ 'BuilderNoEllipses' | translate}}</button>
                <button
                        soho-button="secondary"
                        [disabled]="isReadOnly"
                        (click)="onPreviewButtonEvent($event)"
                >{{ 'PreviewNoEllipses' | translate }}</button>
            </div>
        </ng-container>
        <ng-template #compute>
            <div class="one-button">
                <button
                        soho-button="primary"
                        [disabled]="isReadOnly"
                        (click)="onComputeBuildButtonEvent()"
                >{{ 'BuilderNoEllipses' | translate}}</button>
            </div>
        </ng-template>
    </ng-template>
</ng-container>
